import { Cabins } from "@/modules/AvailabilityCalendar/models/AvailabilityFilter";
import { FilterResponse } from "@/modules/AvailabilityCalendar/models/AvailabilityFiltersResponse";
import useApi from "../../../composables/useApi";
import { computed, ComputedRef, ref } from "vue";
import { useQuery } from "@tanstack/vue-query";

const useAvailabilityFiltersQuery = (route: ComputedRef<string>) => {
    const { get } = useApi();

    const isLoading = ref(false);

    const getCabins = () => {
        isLoading.value = true;
        return get<FilterResponse[]>(`/availability/cabins/${route.value}`, {})
            .then((resp) => new Cabins(resp.data).cabins)
            .finally(() => (isLoading.value = false));
    };

    const queryKey = computed(() => ["cabins", route.value]);

    return {
        ...useQuery({
            queryKey,
            queryFn: getCabins,
            enabled: computed(() => !!route.value),
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            retry: false,
        }),
        isLoading,
    };
};

export default useAvailabilityFiltersQuery;
